module.exports = __webpack_public_path__ + "img/Steor-Icon-11.b1b98397.svg";